import React from "react";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";
import { partnerLogo } from "../selectors/auth";
import { push } from "react-router-redux/actions";

export default connect(
  (state, ownProps) => ({
    partnerLogoHash: partnerLogo(state),
  }),
  (dispatch, ownProps) => ({
    onLogoClick: event => {
      event.preventDefault();
      dispatch(push("/"));
    },
  }),
)(({ partnerLogoHash, onLogoClick }) => (
  <div className="logo-container">
    <a id="logo" className="logo" href="/" onClick={onLogoClick}>
      <Image
        alt="logo"
        style={{ width: "auto" }}
        src={`/api/oncall/public/logo/${partnerLogoHash}`}
      />
    </a>
    <div className="text-center slogan">On-Call Scheduling</div>
  </div>
));



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/Logo.js